import templateUrl from "./timeline-main.html";
import timelineTemplate1Url from "../timeline-template1.html";
// import map from 'lodash/map';
// import filter from 'lodash/filter';
// import size from 'lodash/size';
// import findIndex from 'lodash/findIndex';
// import omit from 'lodash/omit';

export const timelineMainComponent = {
  templateUrl,
  bindings: {
    details: "<",
    onSubmit: "&",
    onCancel: "&",
    disableButtons: "<",
    questionId: "<",
    isAdded: "@",
  },
  controller: class TimelineMainComponent {
    constructor(
      $state,
      $stateParams,
      $timeout,
      toastr,
      $anchorScroll,
      TimelineService,
      AuthService,
      ModalService,
      CompareObjectService,
      Constants,
      DateService
    ) {
      "ngInject";
      this.$state = $state;
      this.$stateParams = $stateParams;
      this.$timeout = $timeout;
      this.$anchorScroll = $anchorScroll;
      this.compareObjectService = CompareObjectService;
      this.TimelineService = TimelineService;
      this.authService = AuthService;
      this.modalService = ModalService;
      this.Constants = Constants;
      this.dateService = DateService;
      this.toastr = toastr;
      this.isEnable = true;
    }

    $onInit() {
      this.hasVideoValidationError = false;
      this.questionId =
        this.$stateParams.questionId === undefined
          ? null
          : this.$stateParams.questionId;
      this.disableButttonSubmit = false;
      this.userRole = this.authService.getUser().role;
      this.timelineTemplate1Url = timelineTemplate1Url;
      this.displayPage1 = this.questionId !== null ? false : true;
      this.displayPage2 = this.questionId !== null ? true : false;
      this.details = this.details || {
        title: "",
        bodyColor: "",
        borderColor: "",
        noOfQuestions: null,
        questions: [],
        taskLink: "",
        taskList: [],
        isEnable: true,
      };
      this.title = this.details.title ? this.details.title : "add new timeline";
      this.saveData = angular.copy(this.details);
    }
    onClickNextButton() {
      if (
        this.details.taskLink &&
        !/http(?:s?):\/\/(?:www\.)?youtu(?:be\.com\/watch\?v=|\.be\/)([\w\-\_]*)(&(amp;)?‌​[\w\?‌​=]*)?/.test(
          this.details.taskLink
        )
      ) {
        this.hasVideoValidationError = true;
      } else {
        this.hasVideoValidationError = false;
      }
      this.disableButttonSubmit = true;

      if (
        this.saveData.noOfQuestions <= this.details.noOfQuestions &&
        !this.hasVideoValidationError
      ) {
        this._activateMultipleDayEventPage();
        this.disableButttonSubmit = false;
      } else {
        this.disableButttonSubmit = false;
        if (this.saveData.noOfQuestions > this.details.noOfQuestions) {
          this.toastr.error("no.of question should be higher than the orignal");
        }
      }
    }
    onUserOptionChange(option) {
      this.details.surveyFor = option.key;
    }
    _onCancel() {
      const isUpdated = this.compareObjectService.deepCompareObjectHasChanged(
        this.saveData,
        this.details,
        false
      );
      this.onCancel({
        isUpdated: isUpdated,
      });
    }
    onGoBack(details) {
      this.details = details;
      this._activateSingleDayEventPage();
    }
    _activateMultipleDayEventPage() {
      this.displayPage1 = false;
      this.displayPage2 = true;
    }
    _activateSingleDayEventPage() {
      this.displayPage1 = true;
      this.displayPage2 = false;
    }
    _onSubmit() {
      setTimeout((_) => {
        this.onSubmit({
          details: this.details,
        });
      }, 100);
    }
  },
};



// WEBPACK FOOTER //
// ./src/app/components/timeline/timeline-main/timeline-main.component.js